import { Pipe, PipeTransform, Injectable } from '@angular/core';

import * as dataCore from "./datacore";

@Pipe({
    name: "crewFilterBySortTag",
    pure: false
})
@Injectable()
export class FilterBySortTagPipe implements PipeTransform {

    transform(items: any[]): any[] {

        if (!items || !items.length) {
            return null;
        }
        
        return dataCore.orderBySortTagThenName(items);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/filter-by-sorttag.pipe.ts